import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { FaFileAlt, FaGlobe, FaBookmark, FaVolumeUp, FaBook } from 'react-icons/fa';
import { AiOutlineFileSearch } from "react-icons/ai";
import { GrTextAlignLeft } from "react-icons/gr";
import { BsFileEarmarkCode, BsFiletypeHtml } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import servicesTranslations from '../../constants/servicesTrasnlations.json'; 
import Avatar from "@mui/material/Avatar";
import { PiFileHtml } from "react-icons/pi";



const iconMap = {
  'OCR': <FaFileAlt />,
  'Translation': <FaGlobe />,
  'Summary': <GrTextAlignLeft />,
  'Bookmarking': <FaBookmark />,
  'Text to Speech': <FaVolumeUp />,
  'Diacritics': <span>ضَ</span>,
  'XML': <BsFileEarmarkCode />,
  'Searchable PDF': <AiOutlineFileSearch />,
  'EPUB': <FaBook />,
  'HOCR': <BsFiletypeHtml />,
  'SINGLE_HTML': <PiFileHtml/>,
  'MULTIPLE_HTML': <BsFiletypeHtml/>,
};

const getColorByStatus = (status) => {
  switch (status) {
    case "COMPLETED":
      return {
        border: "#02b0c7",
        icon: "#02b0c7",
        bg: "rgba(2,132,199,0.1)",
      };
    case "ERROR":
      return {
        border: "#dc2626",
        icon: "#dc2626",
        bg: "rgba(220,38,38,0.1)",
      };
    case "PARTIAL_ERROR":
      return {
        border: "#f97316",
        icon: "#f97316",
        bg: "rgba(220, 135, 38, 0.1)",
      };
    default:
      return {
        border: "#9ca3af",
        icon: "#6b7280",
        bg: "rgba(156,163,175,0.1)",
      };
  }
};

const ServicesIcon = ({ serviceName, status, size = 15, slug }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const serviceKey = Object.keys(servicesTranslations.en).find(
    key =>
      servicesTranslations[lang]?.[key] === serviceName ||
      key === serviceName
  );

  const mappedServiceName =
      serviceKey === slug ?
          servicesTranslations[lang]?.[serviceKey] || serviceName :
          `${servicesTranslations[lang]?.[serviceKey]} (${servicesTranslations[lang]?.[slug] || slug})` || serviceName;

  const icon = iconMap[serviceKey] || <FaFileAlt />;
  const { border, icon: iconColor, bg } = getColorByStatus(status);



  return (
    <Tooltip title={mappedServiceName} arrow>
      <Avatar
          sx={{
            width: 30,
            height: 30,
            backgroundColor: bg,
            border: `1px solid ${border}`,
            color: iconColor,
            fontSize: "0.8rem",
          }}
      >
        {icon}
      </Avatar>
    </Tooltip>
  );
};
ServicesIcon.propTypes = {
  serviceName: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  size: PropTypes.number
};


export default ServicesIcon;
